/**
 * ECharts 트리셰이킹 엔트리 — 앱 전체에서 이 모듈만 import할 것.
 * `import * as echarts from "echarts"` / `import X from "echarts-for-react"` (풀 패키지) 사용 금지.
 *
 * 등록 목록 (2026-09-26 전수 조사 기준):
 * - 차트: line / bar / pie / candlestick / treemap
 * - 컴포넌트: grid / tooltip(+axisPointer) / legend / title / dataZoom(inside+slider)
 *             / markPoint / markLine / markArea / graphic
 * - 렌더러: Canvas
 * 신규 차트 타입·컴포넌트 사용 시 여기에 추가할 것 (미등록 series type은 빈 화면만 나옴)
 */
import * as echarts from "echarts/core";
import type { SeriesOption } from "echarts/types/dist/shared";
import {
  LineChart,
  BarChart,
  PieChart,
  CandlestickChart,
  TreemapChart,
} from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  MarkPointComponent,
  MarkLineComponent,
  MarkAreaComponent,
  GraphicComponent,
  AxisPointerComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

let registered = false;

/** 앱에서 1회만 등록 (모듈 로드 시 1회 보장) */
export const ensureEchartsModules = () => {
  if (registered) return;
  echarts.use([
    // 차트
    LineChart,
    BarChart,
    PieChart,
    CandlestickChart,
    TreemapChart,
    // 컴포넌트
    GridComponent,
    TooltipComponent,
    AxisPointerComponent,
    LegendComponent,
    TitleComponent,
    DataZoomComponent,
    DataZoomInsideComponent,
    DataZoomSliderComponent,
    MarkPointComponent,
    MarkLineComponent,
    MarkAreaComponent,
    GraphicComponent,
    // 렌더러
    CanvasRenderer,
  ]);
  registered = true;
};

ensureEchartsModules();

export type { SeriesOption };
export default echarts;
export { echarts };
